export class EsportsSlide {
  _id?: string;
  name: string = '';
  image: string = '';
  background: string = '';
  title: string = '';
  url: string = '';
  content: string = '';
  mode: 'img-txt' | 'txt-img' = 'img-txt';
  position: number = 0;
  active: boolean = false;
  created: Date;
  updated: Date;
  slug: string = '';
  bgDesktop: string = '';
  bgMobile: string = '';
  contentAlign: 'left' | 'right' = 'left';
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/shared/esports-slide.model.ts